import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-menu-item" }
const _hoisted_2 = {
  key: 0,
  class: "menu-group"
}
const _hoisted_3 = { class: "group-title flex align-items__center" }

import {ref} from "vue";
  import {Menu} from "./type";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'h-menu-item',
  props: {
    menu: {},
    active: {}
  },
  setup(__props: any) {

  const props = __props;

  const subMenuEvent = (data: Menu) => {
    window.history.pushState(null, '', `/${data.app}${data.path}`);
    // 主动触发一次popstate事件
    window.dispatchEvent(new PopStateEvent('popstate', { state: null }));
  }

return (_ctx: any,_cache: any) => {
  const _component_h_menu_item = _resolveComponent("h-menu-item", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.menu.children && _ctx.menu.children.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.menu.icon)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["iconfont m-r__4", _ctx.menu.icon])
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(!_ctx.menu.icon ? 'm-l-20' : '')
            }, _toDisplayString(_ctx.menu.text), 3)
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.children, (item, index) => {
              return (_openBlock(), _createBlock(_component_h_menu_item, {
                key: index,
                active: _ctx.active,
                menu: item
              }, null, 8, ["active", "menu"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["title flex align-items__center", {'active': _ctx.menu.path == _ctx.active}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (subMenuEvent(_ctx.menu)))
        }, [
          (_ctx.menu.icon)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["iconfont m-r-6", _ctx.menu.icon])
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(!_ctx.menu.icon ? 'm-l-20' : '')
          }, _toDisplayString(_ctx.menu.text), 3)
        ], 2))
  ]))
}
}

})